import React, { useMemo } from 'react';
import { useMatch } from 'react-router-dom';
import { AiAssistant } from './AiAssistant';
import { RealAiAssistantClient } from './client/RealAiAssistantClient';
import { isAuthorized, SUPPORT_ADMIN_PERMISSIONS } from 'security/authorization';
export const AiAssistantWrapper = ({ accessToken, user, children }) => {
    const client = useMemo(() => new RealAiAssistantClient({ accessToken }), [accessToken]);
    // Job pages live under both areas, e.g. /account/jobs/:id/monitoring.
    const jobMatch = useMatch('/:area/jobs/:id/*');
    const jobId = jobMatch?.params.area === 'account' || jobMatch?.params.area === 'admin'
        ? jobMatch.params.id
        : undefined;
    const context = useMemo(() => (jobId ? { jobId } : {}), [jobId]);
    // Temporary rollout gate for this WIP feature — remove once ready for everyone.
    const isEnabled = localStorage.getItem('aiAssistantEnabled') === 'true';
    // Mirrors onboard-service, which limits the assistant to global admins and support.
    const isPermitted = user
        ? isAuthorized(user, SUPPORT_ADMIN_PERMISSIONS)
        : false;
    return (React.createElement(React.Fragment, null,
        children,
        accessToken && isEnabled && isPermitted && (React.createElement(AiAssistant, { client: client, context: context }))));
};
